export default {
  CONDITION: {
    count: null
  },
  VEHICLEHISTORY: {
    count: null
  }
};
